import React from 'react';
import { Link } from "react-router-dom";
import TopNavigation from './TopNavigation';
import Footer from './Footer';
import logoStacked from './img/logo-complex-boss-mobile.png';
import logoHorizontal from './img/logo-complex-boss-desktop.png';
import iconBenefit01 from './img/icon-benefit-01.svg';
import iconBenefit02 from './img/icon-benefit-02.svg';
import iconBenefit03 from './img/icon-benefit-03.svg';
import iconBenefit04 from './img/icon-benefit-04.svg';
import iconBenefit05 from './img/icon-benefit-05.svg';
import iconBenefit06 from './img/icon-benefit-06.svg';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class Benefits extends React.Component {
    // constructor(props: any) {
    //     super(props);
    // }

    render() {
        return (
            <React.Fragment>
                <section id="benefits">
                    <div className="wrapper">
                        <div className="top-wrapper">
                            <TopNavigation />

                            <header id="header">
                                <Link to="/" className="header__wrapper">
                                    <img className="logo logo--stacked" src={logoStacked} alt="logo stacked" />
                                    <img className="logo logo--horizontal" src={logoHorizontal} alt="logo horizontal" />
                                    <p className="header__heading">BIPOC OWNERS WITH SUCCESS-BASED SERVICES</p>
                                </Link>
                            </header>
                        </div>

                        <h2 className="section-heading" data-animation="animate__fadeInDown">Program Benefits</h2>

                        <ul className="benefits__list">
                            <li className="benefits__item" data-animation="animate__fadeInDown">
                                <img src={iconBenefit01} className="benefit__icon" alt=""/>
                                <p className="benefit__body">Weekly 1:1 meetings with in-house experts across Brand Partnerships Studio, Content Development &amp; Production, BI, and more.</p>
                            </li>
                            <li className="benefits__item d100" data-animation="animate__fadeInDown">
                                <img src={iconBenefit02} className="benefit__icon" alt=""/>
                                <p className="benefit__body">$250k worth of promotional value within Complex's ecosystem.</p>
                                </li>
                            <li className="benefits__item d200" data-animation="animate__fadeInDown">
                                <img src={iconBenefit03} className="benefit__icon" alt=""/>
                                <p className="benefit__body">Potential additional amplification across Complex's platform.</p>
                            </li>
                            <li className="benefits__item d300" data-animation="animate__fadeInDown">
                                <img src={iconBenefit04} className="benefit__icon" alt=""/>
                                <p className="benefit__body">Potential inclusion in Complex SHOP spotlight, small business directory and networking opportunities.</p>
                            </li>
                            <li className="benefits__item d400" data-animation="animate__fadeInDown">
                                <img src={iconBenefit05} className="benefit__icon" alt=""/>
                                <p className="benefit__body">Conversations with C-Suite Executives.</p>
                            </li>
                            <li className="benefits__item d500" data-animation="animate__fadeInDown">
                                <img src={iconBenefit06} className="benefit__icon" alt=""/>
                                <p className="benefit__body">Long-term alumni perks.</p>
                            </li>
                        </ul>
                    </div>
                </section>

                <Footer />
            </React.Fragment>
        );
    }

    componentDidMount() {
        var animatedItems = document.querySelectorAll('[data-animation]');

        var animatedItemsOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.7,
        };

        var animatedItemsCallback = function(entries: any, observer: any) {
            entries.forEach(function(entry: any) {
                if (entry.intersectionRatio > 0) {
                    const animationClasses = entry.target.dataset.animation.split(' ');
                    animationClasses.forEach((animationClass: string) => {
                        entry.target.classList.add(animationClass);
                    });
                    entry.target.classList.add('animate__animated');
                }
            });
        };

        var animatedItemsObserver = new IntersectionObserver(animatedItemsCallback, animatedItemsOptions);
        animatedItems.forEach(function(item){
            animatedItemsObserver.observe(item);
        });

        ScrollTrigger.create({
            trigger: '#header',
            id: 'header',
            start: 'top top+=20',
            end: () => `${document.body.clientHeight}`,
            toggleActions: 'play reverse none reverse',
            toggleClass: {
                targets: '#header',
                className: "sticky"
            },
            // markers: true
        });
    }
}

export default Benefits;
